module.exports = __webpack_public_path__ + "static/media/bob-logo-modal.682fe2de.png";